import React from 'react';
export function Agitation() {
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-30">
      <div className="max-w-4xl mx-auto" data-id="element-31">
        <div className="bg-[#1A3257] rounded-2xl shadow-lg p-6 md:p-12 border border-[#1E3A5F]" data-id="element-32">
          <div className="prose prose-lg max-w-none" data-id="element-33">
            <p className="text-lg md:text-2xl text-white leading-relaxed mb-4 md:mb-6 font-medium" data-id="element-34">
              Bycie nauczycielem siatkówki w Polsce dzisiaj nie jest łatwe.
            </p>
            <p className="text-base md:text-lg text-[#E8EAF0] leading-relaxed mb-4" data-id="element-35">
              Co tydzień musisz tworzyć nowe plany lekcji od zera. Każda grupa
              wiekowa wymaga innego podejścia. Rodzice pytają o konkretne wyniki
              i postępy.
            </p>
            <p className="text-base md:text-lg text-[#E8EAF0] leading-relaxed mb-4" data-id="element-36">
              Pracujesz ciężko każdego dnia — ale wciąż czujesz, że brakuje Ci
              jasnego systemu.
            </p>
            <p className="text-base md:text-lg text-[#E8EAF0] leading-relaxed mb-6" data-id="element-37">
              To nie jest Twoja wina. Nikt nigdy nie dał Ci systemu, który
              naprawdę działa.
            </p>

            <div className="my-8 p-5 md:p-7 rounded-lg border-l-4" style={{
            background: 'rgba(230, 57, 70, 0.1)',
            borderLeftColor: '#E63946'
          }} data-id="element-38">
              <p className="italic text-base md:text-lg leading-relaxed" style={{
              color: '#E8EAF0'
            }} data-id="element-39">
                Każda niedziela wieczorem przy laptopie. Każdy poniedziałek z
                improwizowanym planem. Każde zajęcia, po których myślisz, że
                mogłeś przygotować się lepiej. To kończy się dzisiaj.
              </p>
            </div>

            <p className="text-xl md:text-3xl font-display font-bold text-white text-center mt-8" data-id="element-40">
              Aż do dziś.
            </p>
          </div>
        </div>
      </div>
    </section>;
}